import { Component, OnInit, Input } from '@angular/core';
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: 'ct-user-image',
  templateUrl: './user-image.component.html',
  styleUrls: ['./user-image.component.css']
})
export class UserImageComponent implements OnInit {
  @Input()
  userId: string;
  public source: string;
  constructor(private utilityService: UtilityService) {}

  ngOnInit() {
    this.source = this.utilityService.getUserImageUrl(this.userId);
  }
}
